module.exports = __webpack_public_path__ + "static/img/81_tomato sauce.74657153.jpg";